import CustomerContactModel from "@/models/crm/CustomerContactModel";
import CrmServiceCollection from "@/collections/CrmServiceCollection";

/**
 * Customer collection
 */
export default class CustomerContactCollection extends CrmServiceCollection {

  // Model that is contained in this collection.
  model() {
    return CustomerContactModel;
  }

}
